<script setup lang="ts">
import NovaInputText, { type Props as NovaInputTextProps } from "@/ui-kit/NovaInputText/NovaInputText.vue";

type Props = Omit<NovaInputTextProps, "showMetrics" | "metricType">;

defineProps<Props>();

const model = defineModel<string>();
</script>

<template>
  <NovaInputText
    v-bind="$props"
    v-model="model"
    :placeholder="placeholder ?? $t('experience.title.input.placeholder')"
    :readonly-placeholder="readonlyPlaceholder ?? $t('common.no-content')"
    :show-metrics="true"
    metric-type="characters"
  >
    <slot />
  </NovaInputText>
</template>
